import { Component, ErrorHandler, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Role, Session } from 'src/app/core/session/session';
import { SessionService } from 'src/app/core/session/session.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { ADGroupConfig } from '../model-backoffice/auth/ad-group.config';
import { BackofficeSsuPermission } from '../model-backoffice/auth/cc-backoffice-permission.config';


@Component({
    selector: 'app-profile-detail',
    templateUrl: './profile-detail.component.html',
    styleUrls: ['./profile-detail.component.scss'],
    standalone: false
})
export class ProfileDetailComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly sessionService = inject(SessionService);
  private readonly navigationService = inject(NavigationService);
  private readonly errorHandler = inject(ErrorHandler);

  private readonly subcription: Subscription = new Subscription();
  session?: Session;
  roles: Role[] = [];
  ssus: BackofficeSsuPermission = [];
  adGroups: ADGroupConfig[] = [];

  ngOnDestroy() {
    this.subcription.unsubscribe();
  }
  ngOnInit() {
    this.session = this.sessionService.getSession();
    this.navigationService.setTitle(this.session?.name || '');
    if (this.session) {
      this.roles = this.session.roles;
      this.ssus = this.session.ssus;
      this.adGroups = this.session.adGroups;
    }
  }


  get adGroupNames(): string {
    return this.adGroups.map(group => group.name).join(', ');
  }

  get appRoleIds(): string {
    return this.roles.join(', ');
  }

  get ssuList(): string {
    return this.ssus === 'all' ? 'all' : this.ssus.join(', ');
  }


  back() {
    this.router.navigate(['/']).catch(error => this.errorHandler.handleError(error));
  }
}
